import React, { useEffect, useState, useRef } from "react";
import handleClick from "../../utils/handleClick.js";
import "./Pins3D.css";

function Pins3D({
  isVisible,
  setIsVisible,
  useCepStorage,
  saveCepStorage,
  getCepStorage,
  optionsPath,
  selectedTag,
  buttonTags,
  generateButtonTags,
  button,
}) {
  const MAX_PIXEL_SIZE = `${optionsPath}.maxPixelSize`;
  const [maxPixelSize, setMaxPixelSize] = useCepStorage(MAX_PIXEL_SIZE);

  useEffect(() => {
  if (!maxPixelSize || maxPixelSize < 27500) {
    setMaxPixelSize(27500);
  }
}, [maxPixelSize, setMaxPixelSize]);

    useEffect(() => {
      saveCepStorage(MAX_PIXEL_SIZE, maxPixelSize);
    }, [maxPixelSize, isVisible]);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <div dangerouslySetInnerHTML={{ __html: button.icon }} />
        </div>
        <div className="button-card__title">3D Pins</div>
        {generateButtonTags()}
      </li>
      <div className={`render-group ${isVisible ? "" : "hidden"}`}>
        <div className="easeKey-sliderContainer pins3D-slider">
          <span className="auto__beat_span">Max Size</span>
          <input
            type="range"
            min="27500"
            max="40000"
            step="0.1"
            value={maxPixelSize}
            onChange={(e) => setMaxPixelSize(Math.round(e.target.value))}
          />
          <span className="easeKey-value">{Math.round(maxPixelSize)}</span>
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() => handleClick("pins3DtoPP", {type: "layer", maxPixelSize:Number(maxPixelSize)})}
            className="resolution-tools__button"
          >
            <i class="fa-light fa-layer-group"></i>
            <span>Selected Layers</span>
          </div>
          <div
            onClick={() => handleClick("pins3DtoPP", {type: "comp", maxPixelSize:Number(maxPixelSize)})}
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-image-polaroid"></i>
            <span>Active Comp</span>
          </div>
          <div
            onClick={() => handleClick("pins3DtoPP", {type: "selected comp", maxPixelSize:Number(maxPixelSize)})}
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-images"></i>
            <span>Selected Comps</span>
          </div>
          <div
            onClick={() => handleClick("pins3DtoPP", {type: "project", maxPixelSize:Number(maxPixelSize)})}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-photo-film"></i>
            <span>Project</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Pins3D;
